export default {
  app: 'APP_BCG',
  api: 'http://localhost:8080/portal'
};
